import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import toArray from "dayjs/plugin/toArray";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/es";

dayjs.extend(customParseFormat);
dayjs.extend(toArray);
dayjs.extend(isBetween);
dayjs.extend(updateLocale);

dayjs.updateLocale("en", { weekStart: 1 });

export default dayjs;
